import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { IUserUiStateShared } from '@app/api/interfaces/user-ui-state-shared.interface';

@Injectable({
  providedIn: 'root',
})
export class UserUiStateSharedApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public get(): Observable<IApiResponse<IUserUiStateShared, object>> {
    const url = `${environment.apiBaseUrl}/v1/user/ui-states/shared`;

    return this.httpClient.get<IApiResponse<IUserUiStateShared, object>>(url, {
      withCredentials: true,
    });
  }

  public update(state: IUserUiStateShared): Observable<IApiResponse<IUserUiStateShared, object>> {
    const url = `${environment.apiBaseUrl}/v1/user/ui-states/shared`;

    return this.httpClient.put<IApiResponse<IUserUiStateShared, object>>(
      url,
      { ...state },
      {
        withCredentials: true,
      }
    );
  }
}
